import { tokeActivationTabs } from './mock/activarData.js';

angular.module('Toke').factory('activarRepository', function ($q) {

    function getActivar() {
        return $q.resolve(tokeActivationTabs)
    }

    // para lista futura
    // function getActivarFromList() {

    //     const listUrl =
    //         baseUrl +
    //         "/_api/web/lists/getbytitle('Intro')/items" +
    //         "?$select=Title,Url,ParentId,Order,IsActive" +
    //         "&$orderby=Order asc";

    //     return $http({
    //         method: 'GET',
    //         url: listUrl,
    //         headers: {
    //             Accept: 'application/json;odata=nometadata'
    //         }
    //     }).then(function (response) {
    //         return response.data.value;
    //     });
    // }



    return {
        getActivar: getActivar
    };

});

